import {Component, Inject, OnInit} from '@angular/core';
import {ViewSelectSnapshot} from '@ngxs-labs/select-snapshot';
import {ConnectionsSelectors, CreateBotConnection, RemoveBotConnection, UpdateBotConnection} from '../../../../core/store/bot-connections';
import {FormBuilder, Validators} from '@angular/forms';
import {Store} from '@ngxs/store';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'brn-discord-connection-modal',
  templateUrl: './discord-connection-modal.component.html',
  styleUrls: ['./discord-connection-modal.component.scss']
})
export class DiscordConnectionModalComponent implements OnInit {
  @ViewSelectSnapshot(ConnectionsSelectors.pendingStatus)
  pendingStatus!: boolean;

  newConnection = true;

  discordForm = this.formBuilder.group({
    app_id: ['', Validators.required],
    bot_token: ['', Validators.required],
    permissions: ['', Validators.required],
  });

  constructor(
    private store: Store,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<DiscordConnectionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data.providerData) {
      this.newConnection = false;
      this.discordForm.patchValue(data.providerData);
    }
  }

  ngOnInit(): void {}

  get validForm(): boolean {
    return this.discordForm.valid;
  }

  createConnection(): void {
    if (!this.validForm || this.pendingStatus) {
      return;
    }
    const providerData = this.discordForm.value;
    this.store.dispatch(new CreateBotConnection('discord', providerData));
  }

  updateConnection(): void {
    if (!this.validForm || this.pendingStatus) {
      return;
    }
    const providerData = this.discordForm.value;
    this.store.dispatch(new UpdateBotConnection('discord', providerData));
  }

  removeConnection(): void {
    if (this.pendingStatus) {
      return;
    }
    this.store.dispatch(new RemoveBotConnection('discord'));
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
